import { render, staticRenderFns } from "./SmtpCampaigns.vue?vue&type=template&id=e8bc0744&scoped=true"
import script from "./SmtpCampaigns.vue?vue&type=script&lang=js"
export * from "./SmtpCampaigns.vue?vue&type=script&lang=js"
import style0 from "./SmtpCampaigns.vue?vue&type=style&index=0&id=e8bc0744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8bc0744",
  null
  
)

export default component.exports